import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

const Spinner: React.FC<{ className?: string; label?: string }> = ({
  className,
  label = "Laden",
}) => <Loader2 role="status" aria-label={label} className={cn("size-4 animate-spin", className)} />;

export default Spinner;
